module.exports = __webpack_public_path__ + "media/images/android@2x-36ffdd0808dcd5e63f447e74f3e8b3c1.png";